"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ComparableHomesOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M11.84 11.29a2 2 0 00-2.74 0l-6.47 6.12A2 2 0 002 18.86V28a2 2 0 002 2h13a2 2 0 002-2v-9.13a2 2 0 00-.63-1.46zM17 28H4v-9.14l6.47-6.11L17 18.87z"/><path d="M7.71 21.29a1 1 0 00-1.42 1.42l2 2A1 1 0 009 25a1 1 0 00.62-.22l5-4a1 1 0 10-1.24-1.56l-4.31 3.44zM25.88 8.22l-1.81 1.44-.36-.37a1 1 0 00-1.42 1.42l1 1A1 1 0 0024 12a1 1 0 00.62-.22l2.5-2a1 1 0 10-1.24-1.56z"/><path d="M29.35 6.17l-4.18-3.9a1 1 0 00-1.34 0l-4.18 3.9A2.1 2.1 0 0019 7.69V14a1 1 0 001 1h9a1 1 0 001-1V7.69a2.1 2.1 0 00-.65-1.52zM28 13h-7V7.69v-.06l3.5-3.25L28 7.63v.06z"/>';
var ComparableHomesOutlineSVG = function ComparableHomesOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ComparableHomesOutlineSVG = ComparableHomesOutlineSVG;
ComparableHomesOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ComparableHomesOutlineSVG);
exports.default = _default;